import { appointmentTypesApi } from '~/api';

const actionPrefix = (actionType) => `AppointmentType/${actionType}`;

export const SET_APPOINTMENT_TYPES = actionPrefix`SET_APPOINTMENT_TYPES`;
export const setAppointmentTypes = (appointmentTypes) => ({
  type: SET_APPOINTMENT_TYPES,
  payload: appointmentTypes,
});

export const loadAppointmentTypeList = (dispatch, storeId, queryParams) =>
  appointmentTypesApi.getAppointmentTypes(queryParams, storeId).then(({ types }) => {
    dispatch(setAppointmentTypes(types));
  });

export const loadAppointmentTypes = (storeId) => (dispatch) => {
  return loadAppointmentTypeList(dispatch, storeId);
};

export const appointmentTypesActions = {
  loadAppointmentTypes,
};
